import { ChildrenBlockSpacingContainer } from '@dreamstack/accentro-contentful/src/contentful/ChildrenBlockSpacingContainer'
import { ContentfulBlocks } from '@dreamstack/accentro-contentful/src/contentful/ContentfulBlocks'
import { RouterOutputs } from '@dreamstack/trpc/client'
import isEmpty from 'lodash/isEmpty'
import type { FunctionComponent } from 'react'

export const ProjectPageBlocks: FunctionComponent<
  React.PropsWithChildren<{
    blockField: 'blocksBelowImages'
    projectPage: RouterOutputs['cms']['getProjectPage'] | undefined
  }>
> = ({ blockField, projectPage }) => {
  const blocks = projectPage?.[blockField]

  if (!blocks || isEmpty(blocks)) return null

  return (
    <div className="col-span-full">
      <div className="mb-px-64 col-span-full ml:mb-px-96">
        <ChildrenBlockSpacingContainer>
          <ContentfulBlocks blocks={blocks} />
        </ChildrenBlockSpacingContainer>
      </div>
    </div>
  )
}
